<template>
  <div class="container">
    <div class="box">
      <restaurant-form :id="id"></restaurant-form>
    </div>
  </div>
</template>

<script>
import RestaurantForm from './RestaurantForm';

export default {
  name: 'edit-Restaurant',
  props: ['id'],
  components: {
    RestaurantForm,
  },
};

</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/restaurant/EditRestaurant.vue